import type { AccountTableView } from "@bitwarden/web-vault/app/models/types/account.types";

/**
 * Builds a dedup key for the account table rows from the fields that are actually
 * rendered and can change without the set of accounts changing — balance, sync
 * status, interest rate, and display metadata (name/institution/logo/product/
 * currency/type). Keying on id alone (the previous behaviour) caused balance/
 * status updates from a sync — and later, renames/institution changes — to be
 * suppressed until a full page refresh, because the account ids stayed the same.
 * Deliberately uses `statusPoint.key` only, never the full statusPoint object —
 * it carries a `dc` timestamp that's regenerated on every call and would make
 * the hash change on every recompute regardless of real changes.
 */
export function hashAccountTableViews(views: AccountTableView[]): string {
  return views
    .map(
      (v) =>
        `${v.id}:${v.balance}:${v.statusPoint?.key ?? ""}:${v.interestRate}:${v.name}:` +
        `${v.institution ?? ""}:${v.full_logo_url ?? ""}:${v.square_logo_url ?? ""}:` +
        `${v.accountProductName ?? ""}:${v.currency ?? ""}:${v.type ?? ""}`,
    )
    .sort()
    .join("|");
}
